export const LOREM_WORDS = (
  "lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut " +
  "labore et dolore magna aliqua ut enim ad minim veniam quis nostrud exercitation ullamco " +
  "laboris nisi ut aliquip ex ea commodo consequat duis aute irure dolor in reprehenderit in " +
  "voluptate velit esse cillum dolore eu fugiat nulla pariatur excepteur sint occaecat " +
  "cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborum"
).split(" ")

// Words for posters: short, loud, Latin
export const POSTER_WORDS = [
  "LUX",
  "ARS",
  "VITA",
  "SOL",
  "AQUA",
  "ROTA",
  "NOVA",
  "PAX",
  "VOX",
  "MARE",
  "OPUS",
  "LUNA",
  "UNDA",
  "NOX",
  "LEX",
  "ROSA",
  "FLOS",
  "IRIS",
  "AURA",
  "RES",
  "REX",
  "IGNIS",
] as const

// Where a poster is from: cities by their Latin names
export const POSTER_CITIES = [
  "ROMA",
  "POMPEII",
  "SYRACUSAE",
  "NEAPOLIS",
  "MEDIOLANUM",
  "FLORENTIA",
  "VENETIAE",
  "RAVENNA",
  "OSTIA",
  "CAPUA",
  "VERONA",
  "TARENTUM",
] as const

export const TITLE = "Example"

// The word the posters open on, page 1's
export const POSTER_TITLE = "SAMPLE"

export const PUBLISHER = "EDITIONES ROMANAE"
